export const PERSONAL_TEAM_ID = `__GATSBY_VERCEL_PERSONAL_TEAM__`

export function parseVercelTeamId(teamId: string | null): string {
  return teamId || PERSONAL_TEAM_ID
}

export function normalizeVercelTeamId(teamId: string): string | null {
  return teamId === PERSONAL_TEAM_ID ? null : teamId
}

export function getInitialVercelTeam(teams: Record<string, string>[]) {
  if (!teams || teams.length === 0) {
    return ``
  }

  const initialTeam = teams[0]

  if (initialTeam?.id === PERSONAL_TEAM_ID) {
    return ``
  }

  return initialTeam?.slug
}
